import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { changePageTitle } from 'src/domains/global/actions'
import * as types from '../types'

const System: React.FC<types.SystemConf> = ({ type }) => {
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(changePageTitle('System'))
    })

    return (
        <div className="content">
            <h1 className="heading">
                Google Fonts in React
            </h1>
            <h2 className="subheading">
                Learn how to add fonts in a React Project
            </h2>
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
            <hr />
            <h1>Heading 1</h1>
            <h2>Heading 2</h2>
            <h3>Heading 3</h3>
        </div>
    )
}

export default System
